import React from 'react'
import { t } from '../i18n'

// Last line of defence: a render error shows a reload screen instead of a
// blank white page. Browser translators editing the page are a common cause.
export default class ErrorBoundary extends React.Component {
  state = { failed: false }

  static getDerivedStateFromError() {
    return { failed: true }
  }

  componentDidCatch(error, info) {
    console.error('App crashed:', error, info?.componentStack)
  }

  render() {
    if (!this.state.failed) return this.props.children
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50 px-4">
        <div className="max-w-md text-center">
          <h1 className="text-2xl font-bold text-slate-900">{t('Something went wrong')}</h1>
          <p className="mt-3 text-slate-600">{t("Please reload the page. If you use your browser's translate feature, turn it off for this site.")}</p>
          <button type="button" onClick={() => window.location.reload()}
            className="mt-6 rounded-xl bg-blue-700 px-6 py-3 font-semibold text-white hover:bg-blue-800">
            {t('Reload page')}
          </button>
        </div>
      </div>
    )
  }
}
